import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/join/gou.png'
import _imports_1 from '../../assets/join/congwu1.png'
import _imports_2 from '../../assets/join/NFTWEB.png'


const _withScopeId = n => (_pushScopeId("data-v-6a86d45f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main flex flex-col items-center justify-center mx-auto mt-2" }
const _hoisted_2 = {
  class: "w-96",
  style: {"background":"transparent"}
}
const _hoisted_3 = {
  style: {"background":"#2E2B4F"},
  class: "m-2 p-2 px-10 py-16 rounded-b-full rounded-t-full relative"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-3 h-3 rounded-full bg-[#3D3B52]" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_5 = { style: {"color":"#FFFF9F"} }
const _hoisted_6 = { class: "text-white text-xs" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "absolute left-0 w-1/3",
  style: {"top":"-1rem"},
  src: _imports_1
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "absolute right-0 w-1/3",
  style: {"bottom":"-1rem"},
  src: _imports_1
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "",
  src: _imports_2
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_timeline_item = _resolveComponent("a-timeline-item")!
  const _component_a_timeline = _resolveComponent("a-timeline")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_a_timeline, { mode: "alternate" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.timearr, (item) => {
              return (_openBlock(), _createBlock(_component_a_timeline_item, {
                color: "green",
                key: item.index
              }, _createSlots({
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(item.time), 1),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(item.desc), 1)
                ]),
                _: 2
              }, [
                (item.time=='2023-07')
                  ? {
                      name: "dot",
                      fn: _withCtx(() => [
                        _hoisted_4
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1024))
            }), 128))
          ]),
          _: 1
        }),
        _hoisted_7,
        _hoisted_8
      ]),
      _hoisted_9
    ])
  ]))
}